import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  EndpointKeys,
  IDP_APP
} from '../models/constants/search-config.constant';
import { TripFlags } from '../models/interface/request.interface';
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(private http: HttpClient, private appConfig: AppConfigService) {}
  errorHandler = handleError.bind(this);

  getTripsFlag = (): Observable<TripFlags> => {
    const response = new ApiBuilder<undefined, TripFlags>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(EndpointKeys.FEATURE_FLAG)
      .method(HttpRequestMethods.GET)
      .errorHandler(this.errorHandler)
      .create()
      .pipe(shareReplay());
    return response;
  };
}
